export default __webpack_public_path__ + "static/media/up-lite.f0e01b50.svg";